import React from 'react'
import { format } from 'date-fns'
import { Link, useParams } from 'react-router-dom'
import { RightArrowIcon } from 'components/Icons'
import Avatar from './Avatar'
import { TradeBadges } from './TradieDisplay'

function ListRows({ tradies }) {
  const { companyId } = useParams()

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Trade(s)</th>
            <th>Total Check-ins</th>
            <th>Last Check-in</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tradies.map((t) => (
            <tr key={t._id}>
              <td>
                <div className="name-cell">
                  <Avatar firstName={t.firstName} surname={t.surname} />
                  {t.firstName} {t.surname}
                </div>
              </td>
              <td>{t.phone}</td>
              <td>
                <div className="trades-cell">
                  <TradeBadges trades={t.trades} otherTrade={t.otherTrade} />
                </div>
              </td>
              <td className="center">{t.totalCheckins}</td>
              <td>{t.lastCheckinAt ? format(new Date(t.lastCheckinAt), 'd MMM yyyy') : '—'}</td>
              <td>
                <Link
                  className="details-link"
                  to={`/company/${companyId}/my-tradies/${t._id}`}
                  aria-label={`View ${t.firstName} ${t.surname} details`}
                >
                  <RightArrowIcon width="10" height="14" fill="var(--font-color)" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default function TradeGroup({ label, tradies, open, onToggle }) {
  return (
    <div className="trade-group">
      <button
        type="button"
        className="trade-group__header"
        onClick={onToggle}
        aria-expanded={open}
        aria-label={`Toggle ${label} trade group`}
      >
        <span className="trade-group__chevron">{open ? '▼' : '▶'}</span>
        <span className="trade-group__name">{label}</span>
        <span className="trade-group__count">{tradies.length}</span>
      </button>
      {open && <ListRows tradies={tradies} />}
    </div>
  )
}
